import * as React from 'react';
import './container.css';

export const containerHabitat: React.StatelessComponent<{}> = ({ children }) => {
  return <div className="container-habitat">{children}</div>;
};
